import { SERIES_COLORS } from '../../../../../CommonComponents/OPL/charts/charts.constants';

export const cashColor = '#0E9F6E';

export const chartColors = SERIES_COLORS.filter(color => color !== cashColor);
